import { render } from "./clear-tab.vue?vue&type=template&id=922707a2&scoped=true"
import script from "./clear-tab.vue?vue&type=script&lang=js"
export * from "./clear-tab.vue?vue&type=script&lang=js"

import "./clear-tab.vue?vue&type=style&index=0&id=922707a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-922707a2"]])

export default __exports__